import { observer } from 'mobx-react-lite'
import React, {useContext, useEffect} from 'react'
import { authRoutes, publicRoutes, publicRoutesCatalog, publicRoutesProduct, publicRoutesUser } from '../routes'

import { Route, Routes, useLocation } from 'react-router-dom'
import { useTIdHandler } from '../hooks/useTIdHandler'
import useUTMPromocode from '../hooks/useUTMPromocode'
import { Context } from '../index'
import LoadingAdmin from '../pages/administrator/LoadingAdmin'
import Fashion from '../pages/content/fashion/Fashion'
import { FASHIONS_DETAIL } from '../utils/consts'

const AppRouter = observer(() => {
	const { user } = useContext(Context)
	const location = useLocation()
	let Component = publicRoutesCatalog[0].Component
	let UserComponent = publicRoutesUser[0].Component
	let ProductComponent = publicRoutesProduct[0].Component
	let state = location.state
	useTIdHandler()
	useUTMPromocode()

	if (/\/fashions\/./g.test(location.pathname) && !state) {
		state = {
			backgroundLocation: '/fashions/',
		}
	}

    useEffect(() => {
        if (!window.turboTarget || !window.turboTarget.sendRTGMessage){
            document.addEventListener("generalPixelInited", window.turboTargetPixelRTGVisit );
        } else {
            window.turboTargetPixelRTGVisit();
        }
    }, [location]);

	return (
		<>
			<Routes location={state?.backgroundLocation || location}>
				{user.isAuth &&
					user.user.role === 'ADMIN' &&
					authRoutes.map(({ path, Component }) => <Route key={path} path={path} element={<Component />} />)}

				{publicRoutesUser[0].path.map((path, index) => (
					<Route key={path} path={path} element={<UserComponent />} />
				))}

				{publicRoutesCatalog[0].path.map((path, index) => (
					<Route key={path} path={path} element={<Component />} />
				))}

				{publicRoutesProduct[0].path.map((path) => (
					<Route key={path} path={path} element={<ProductComponent />} />
				))}

				{publicRoutes.map(({ path, Component }) => (
					<Route key={path} path={path} element={<Component />} />
				))}

				<Route exact path={'/admindashboard/*'} element={<LoadingAdmin />} />

				{/*<Route path="*" element={<Navigate to="/content/404/" />} />*/}
			</Routes>

			{!!state?.backgroundLocation && (
				<Routes>
					<Route path={FASHIONS_DETAIL} element={<Fashion />} />
				</Routes>
			)}
		</>
	)
})

export default AppRouter
